import { Button, Drawer, Form, Select, Space, TimePicker } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import moment from "moment";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";

const UpdateInfo = ({ open, close, getMerchantList, selectedData }) => {
  // console.log("SELECTED DATA", selectedData);

  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  var planExpiry = moment(selectedData.merchantinfosubscription.plan_started)
    .add(7, "d")
    .format("YYYY-MM-DD HH:mm:ss");
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);

  const handleUpdateInfo = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("merchant_id", selectedData.user_id);

    formdata.append(
      "final_time_opens",
      dateFrom !== null
        ? dateFrom
        : selectedData !== null && selectedData.operation_opens
    );
    formdata.append(
      "final_time_closes",
      dateTo !== null
        ? dateTo
        : selectedData !== null && selectedData.operation_closes
    );

    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    axios
      .post("user/admin/merchant-info", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated info successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            getMerchantList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Update Info"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="update-info"
        initialValues={{
          remember: true,
          business_category:
            selectedData !== null ? selectedData.business_category : "",
          is_production:
            selectedData !== null ? selectedData.is_production : "",

          operation_opens: dayjs(
            selectedData !== null && selectedData.operation_opens,
            "HH:mm:ss"
          ),
          operation_closes: dayjs(
            selectedData !== null && selectedData.operation_closes,
            "HH:mm:ss"
          ),
        }}
        onFinish={handleUpdateInfo}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="business_category"
            label="Business Category"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select size="large" showSearch>
              <Select.Option value="Food">Food</Select.Option>
              <Select.Option value="Non-food">Non-food</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="is_production"
            label="Allow Production?"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select size="large" showSearch>
              <Select.Option value={1}>Yes</Select.Option>
              <Select.Option value={0}>No</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="operation_opens"
            label="Operation Opens At"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <TimePicker
              format={"HH:mm:ss"}
              onChange={(value, dateString) => {
                var date = `2023-11-23 ${dateString}`;
                setDateFrom(
                  moment(`${date.replace(" ", "T")}.000000Z`)
                    .utc()
                    .format("HH:mm:ss")
                );
              }}
              style={{ width: "100%" }}
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="operation_closes"
            label="Operation Closes At"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <TimePicker
              format={"HH:mm:ss"}
              onChange={(value, dateString) => {
                var date = `2023-11-23 ${dateString}`;
                setDateTo(
                  moment(`${date.replace(" ", "T")}.000000Z`)
                    .utc()
                    .format("HH:mm:ss")
                );
              }}
              style={{ width: "100%" }}
              size="large"
            />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Save"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default UpdateInfo;
